const getIdNameFromLabel = (label: string | string[]): string =>
  Array.isArray(label) ? label.join().replace(/[^\w]/g, '') : label.replace(/[^\w]/g, '');

export default getIdNameFromLabel;
